<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">To Elaina, “Ellie,” my wife and best friend for more than three decades, whose grace and courage through numerous battles with cancer inspired me to write this story.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4bb60802